import React from 'react'
import {Icons} from '../Icons'
import clsx from 'clsx'
interface ButtonProps {
  typeBtn?: 'button' | 'submit' | 'reset'
  typeIcon?: string
  primary?: boolean
  backgroundColor?: string
  size?: 'small'
  label: string
  classNameProp?: string
  variant?: string
  onClick?: () => void
  loading?: boolean
  disabled?: boolean
}

const Button = ({
  typeBtn = 'button',
  typeIcon = '',
  primary = false,
  variant = 'primary',
  size = 'small',
  backgroundColor,
  label,
  classNameProp = '',
  loading = false,
  disabled = false,
  ...props
}: ButtonProps) => {
  const disableBtn = disabled && 'disabledBtn'
  const variantType = variant === 'primary' ? 'sdx_btn ' : 'sdx_btn_secondary '
  const classNames = clsx(variantType, classNameProp, disableBtn)

  return (
    <button
      type={typeBtn}
      className={classNames}
      style={{backgroundColor}}
      disabled={disabled}
      {...props}
    >
      {loading && (
        <div className='icon-container me-2'>
          <i className='loader'></i>
        </div>
      )}
      {!loading && <Icons type={typeIcon} classNameProp='me-2' />}
      {label}
    </button>
  )
}

export default Button
